export default "__VITE_ASSET__f0bd4d46__"